import React from 'react';

import { Root, TimeImg } from './styles';

interface Props {
  children: React.ReactNode;
  isLastFlight: boolean;
}

const TimeBetweenFlights = ({ children, isLastFlight }: Props) => (
  <Root isLastFlight={isLastFlight}>
    <TimeImg src={`/images/${isLastFlight ? 'time.svg' : 'time-info-active.svg'}`} />
    {children}
  </Root>
);

export default TimeBetweenFlights;
